import { API_URL } from "../../../../../../constants";
import * as httpNetworking from "../../../../../../httpNetworking";

const VERSION = 0;

export async function updateOrCreateLicenseKey(
    appId: string,
    data: {
        deploymentId: string;
        featureIds: string[];
    }
): Promise<void> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000
    };

    const url = API_URL + "/saas/multi-tenancy/connection-uri-domain/" + appId + "/license";

    await httpNetworking.simplePUTRequest(url, data, options, VERSION);
}
